import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import { Spring } from 'react-spring';

import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import { WhitelabelActions, alertActions, ReportsActions } from '../../store/actions';
import HeaderComponent from '../../components/Header';
import Footer from '../../components/Footer/footer';
import '../../static/css/styles.css';
import { constants } from '../../Constants';
import Select from 'react-select';
import moment from 'moment';

// import DatePicker from 'react-datepicker';
import DayPickerInput, { DateUtils } from 'react-day-picker/DayPickerInput';
import 'react-day-picker/lib/style.css';
import { formatDate, parseDate } from 'react-day-picker/moment';

// import 'react-datepicker/dist/react-datepicker.css';
import { jsPDF } from 'jspdf';

import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';

// import DayPicker from 'react-day-picker';
// import 'react-day-picker/lib/style.css';

class CorporateReports extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			projectsSelected: [],
			startDate: undefined,
			endDate: undefined,
			from: undefined,
			to: undefined,
		};
	}
	componentWillMount() {
		this.props.resetReports();
		this.props.fetchWhitelabel();
	}
	showFromMonth = () => {
		const { from, to } = this.state;
		if (!from) {
			return;
		}
		if (moment(to).diff(moment(from), 'months') < 2) {
			this.to.getDayPicker().showMonth(from);
		}
	};

	handleFromChange = (from) => {
		// Change the from date and focus the "to" input field
		this.setState({ from });
		
	};

	handleToChange = (to) => {
		this.setState({ to }, this.showFromMonth);
		
	};
	onSearch = () => {
		const { from, to, startDate, endDate, projectsSelected } = this.state;

		let projects = [];
		if (projectsSelected && projectsSelected.length > 0) {
			projectsSelected.map((p) => {
				return projects.push(p.value);
			});
		}
		this.props.fetchSessionsData(
			`${moment(from).format('YYYY-MM-DD')}T00:00:00Z`,
			`${moment(to).format('YYYY-MM-DD')}T23:59:59Z`,
			projects.join(',')
		);
	};

	changeProjects = (projectsSelected) => {
		this.setState({ projectsSelected });
	};

	exportPDF = (e) => {
		return false;
		/*const { reports } = this.props;
		const { data } = reports;
		if (data && data.length > 0) {
			e.preventDefault();

			const reportTemplate = (
				<div className="jumbotron mx-auto">
					<table className="borderless table table-responsive w-100 d-block d-md-table">
						<thead className="text-center table-head-styles">
							{data && data.length > 0 ? (
								<tr className="table-row-styles">
									<th scope="col session-heading">Counsellor</th>

									<th scope="col session-heading">Patient</th>
									<th scope="col session-heading">Patients Email </th>
									<th scope="col session-heading">Schedule</th>
									<th scope="col session-heading">Project</th>

									<th scope="col session-heading">Subsidary</th>
								</tr>
							) : (
								<tr className="text-center">
									<th scope="col session-heading">No appointments to show</th>
								</tr>
							)}
						</thead>
						<tbody className="text-center tableBody">
							{data &&
								data.map((item, i) => {
									return (
										<tr key={i} className="table-text">
											<td className="counsellorData">{item.counsellor_name}</td>
											<td className="counsellorData">{item.patient_name}</td>
											<td className="counsellorData">{item.patient_email}</td>
											<td className="counsellorData">
												{moment(item.date_time)
													.format('ddd DD MMM YYYY hh:mm:ss A')
													.toLocaleString('en-US', {
														hour: 'numeric',
														hour12: true,
													})}
											</td>
											<td className="counsellorData">{item.project_name}</td>
											<td className="counsellorData">{item.subsidiary_name}</td>
										</tr>
									);
								})}
						</tbody>
					</table>
				</div>
			);
			const doc = new jsPDF();

			doc.text(data.join(','), 10, 10);
			doc.save('a4.pdf');
		} else return false;
		*/
	};

	exportToCSV = (e) => {
		e.preventDefault();
		const { reports } = this.props;
		const { data } = reports;
		const { from, to } = this.state;
		if (data && data.length > 0) {
			const csvData = data;
			const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
			const fileExtension = '.xlsx';
			const fileName = `Corporate-Report-${moment(from).format('DD MMM YYYY')}-${moment(to).format(
				'DD MMM YYYY'
			)}`;

			const formattedData = csvData.map(c => {
				c.dat_created = moment(c.dat_created)
					.format('DD MMM YYYY hh:mm:ss A')
					.toLocaleString('en-US', {
						hour: 'numeric',
						hour12: true,
					})
				return c;
			})
			const ws = XLSX.utils.json_to_sheet(formattedData);
			const wb = { Sheets: { data: ws }, SheetNames: ['data'] };
			const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
			const dataSource = new Blob([excelBuffer], { type: fileType });
			FileSaver.saveAs(dataSource, fileName + fileExtension);
		} else return false;
	};

	render() {
		const { from, to, projectsSelected, startDate, endDate } = this.state;

		const modifiers = { start: from, end: to };

		let optionsProjects = [];
		const { whitelabel, reports } = this.props;
		const { data } = reports;
		if (whitelabel && whitelabel.length > 0) {
			whitelabel.map((w) => {
				return optionsProjects.push({ value: w.id, label: w.name });
			});
		}

		return (
			<div className="ContainerFix">
				<HeaderComponent />
				<Spring from={{ transform: 'translate(+100%, 0)' }} to={{ transform: 'translate(0%, 0)' }}>
					{(props) => (
						<div className="containerFlex" style={props}>
							<div className="container-wrap">
								<div className="row mt-5 mx-auto w-75 pb-5" id="cardButtonContainer">
									{/* HEADING CONTAINER STARTS HERE */}
									<div className="heading-container">
										<p className="lead heading-line">Reports</p>
										<div className="reports-search">
											<p className="lead heading-text col-md-7 col-sm-6 col-xs-12 p-0">
												Corporate Reports &nbsp;&nbsp;
												<span className="heading--sub">
													Last seen yesterday at 12:00 by Syed Naseh
												</span>
											</p>
											<form className="form-inline col-md-5 col-sm-6 col-xs-12 search-reports">
												{/* MAIN FILTER BUTTON */}
												<div className="counsellor-btns reports-btn"></div>
												{/* CENTER FILTER BUTTON */}
												<div className="counsellor-btns">
													<button
														className={`excel-btn cancel-submit-button width100 ${data && data.length > 0 ? '' : 'disableCursor'
															}`}
														onClick={this.exportToCSV}
													>
														Excel
													</button>
													<button
														onClick={this.exportPDF}
														className={`appintment-submit-button width100 pdf-btn 
													 disableCursor`}
													>
														PDF
													</button>
												</div>
											</form>
										</div>
										<hr className="lead--heading-line" />
									</div>
									{/* HEADING CONTAINER ENDS HERE */}

									{/* FORM STARTS */}
									<div className="form-inline">
										<div className="col-md-4 col-sm-12 p-0">
											<Select
												value={projectsSelected}
												isMulti
												name="projectsSelected"
												options={optionsProjects}
												placeholder='Select project(s)'
												className="basic-multi-select mr-sm-8 form-control form-control-lg search-input form-control-boder text text-left cstm-select"
												classNamePrefix="select"
												onChange={this.changeProjects}
											/>
										</div>
										<div className="col-md-7 col-sm-12 counsellor-btns search-reports">
											<div className="form-control form-control-lg mr-sm-8 search-input form-control-boder">
												<div className="InputFromTo">
													<DayPickerInput
														value={from}
														placeholder="Start date"
														format="LL"
														formatDate={formatDate}
														parseDate={parseDate}
														// id='stardDate'
														dayPickerProps={{
															selectedDays: [from, { from, to }],
															disabledDays: { after: to },
															toMonth: to,
															modifiers,
															numberOfMonths: 2,
															onDayClick: () => this.to.getInput().focus(),
														}}
														onDayChange={this.handleFromChange}
													/>{' '}
													—{' '}
													<span className="InputFromTo-to">
														<DayPickerInput
															ref={(el) => (this.to = el)}
															value={to}
															placeholder="End date"
															format="LL"
															// id='endDate'
															formatDate={formatDate}
															parseDate={parseDate}
															dayPickerProps={{
																selectedDays: [from, { from, to }],
																disabledDays: { before: from },
																modifiers,
																month: from,
																fromMonth: from,
																numberOfMonths: 2,
															}}
															onDayChange={this.handleToChange}
														/>
													</span>
													<Helmet>
														<style>{`
  .InputFromTo .DayPicker-Day--selected:not(.DayPicker-Day--start):not(.DayPicker-Day--end):not(.DayPicker-Day--outside) {
    background-color: #f0f8ff !important;
    color: #4a90e2;
  }
  .InputFromTo .DayPicker-Day {
    border-radius: 0 !important;
  }
  .InputFromTo .DayPicker-Day--start {
    border-top-left-radius: 50% !important;
    border-bottom-left-radius: 50% !important;
  }
  .InputFromTo .DayPicker-Day--end {
    border-top-right-radius: 50% !important;
    border-bottom-right-radius: 50% !important;
  }
  .InputFromTo .DayPickerInput-Overlay {
    width: 550px;
  }
  .InputFromTo-to .DayPickerInput-Overlay {
    margin-left: -198px;
  }
`}</style>
													</Helmet>
												</div>
											</div>
										</div>
										<div className="col-md-1 col-sm-12 counsellor-btns search-reports">
											<button
												className="btn btn-lg btn-counsellor dark-blue"
												aria-pressed="true"
												onClick={this.onSearch}
											>
												{constants.SEARCH_TXT}
											</button>
										</div>
										{/* FORM ENDS */}
									</div>
									<div className="form-inline" style={{marginBottom: "4rem"}}>

									</div>

									{data ? (
										<div className="jumbotron mx-auto report-jumbotron">
											<table className="borderless table table-responsive w-100 d-block d-md-table reports-tbl">
												<thead className="text-center table-head-styles report-heading">
													<tr className="table-row-styles report-heading-row">
														<th scope="col session-heading">Name</th>
														<th scope="col session-heading">Email</th>
														<th scope="col session-heading">Creation Date </th>
														<th scope="col session-heading">Project</th>
														<th scope="col session-heading">Project Subsidiary</th>
														<th scope="col session-heading" className="report-border-right">
															Verified
														</th>
													</tr>
												</thead>
												{data && data.length > 0 ? (
													<tbody className="text-center tableBody report-table-body">
														{data &&
															data.map((item, i) => {
																//if (!item.total_patients_count)

																if (item.total_patients_count) {
																	return (
																		<tr key={i} className="table-text">
																			<td colSpan='6' className="counsellorData alignEnd">
																				Showing {item.total_patients_count} records
																			</td>
																		</tr>
																	);
																} else return (
																	<tr key={i} className="table-text">
																		<td className="counsellorData">{item.full_name}</td>
																		<td className="counsellorData">
																			{item.email_address}
																		</td>
																		<td className="counsellorData">
																			{moment(item.dat_created)
																				.format('ddd DD MMM YYYY hh:mm:ss A')
																				.toLocaleString('en-US', {
																					hour: 'numeric',
																					hour12: true,
																				})}
																		</td>
																		<td className="counsellorData">{item.project}</td>
																		<td className="counsellorData">
																			{item.subsidiary}
																		</td>
																		<td className="counsellorData">
																			{item.is_verified ? 'Verified' : 'Unverified'}
																		</td>
																	</tr>
																);
															})}
													</tbody>
												) : (
													<tbody>
														<tr className="text-center report-table-nobody">
															<td colSpan="6">No appointments to show</td>
														</tr>
													</tbody>
												)}
											</table>
										</div>
									) : (
										''
									)}
								</div>
							</div>
						</div>
					)}
				</Spring>
				{/* <Example/> */}
				<Footer />
			</div>
		);
	}
}

function mapStateToProps(state) {
	const { auth, alert, CounsellorReports, reports } = state;
	const { user } = auth;

	const authstate = state.auth;
	const { whitelabel } = state.whitelabel;

	return {
		alert,
		user,
		authstate,
		whitelabel,
		reports,
		CounsellorReports,
	};
}

function mapDispatchToProps(dispatch) {
	return {
		fetchWhitelabel: () => {
			dispatch(WhitelabelActions.fetchWhitelabel());
		},
		fetchSessionsData: (startDate, endDate, projects) => {
			dispatch(ReportsActions.fetchCorporateReports(startDate, endDate, projects));
		},
		resetReports: () => {
			dispatch(ReportsActions.resetReports());
		},
		clearAlertActions: () => {
			dispatch(alertActions.clear());
		},
		alertError: (message) => {
			dispatch(alertActions.error(message));
		},
		selectWhitelabel: (id) => {
			dispatch(WhitelabelActions.selectWhitelabel(id));
		},
	};
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CorporateReports));



// WEBPACK FOOTER //
// ./src/screens/CorporateReports/index.js